export default __webpack_public_path__ + "static/media/pers2.86b3bb19.jpg";